import { deviceTypes } from '@styles/mediaQueries';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;

  padding: 24px;
  border: 1px solid #e6e8f0;
  border-radius: 8px;
`;

export const ValueContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;

  [data-device='${deviceTypes.mobile}'] & {
    align-items: baseline;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding-bottom: 24px;
  background-color: #fff;

  align-items: center;
  column-gap: 8px;
`;

export const Counter = styled.div`
  display: flex;
  height: 22px;
  background-color: #edeff4;
  border-radius: 4px;
  padding: 0px 6px;

  font-size: 14px;
  font-weight: 600;
  color: #474d66;
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #1b203a;

  &.subTitle {
    font-size: 12px;
    font-weight: 500;
    color: #696f8c;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 16px;

  overflow: auto;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }

  [data-device='${deviceTypes.mobile}'] & {
    align-items: flex-start;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;

  align-items: center;
  justify-content: space-between;

  [data-device='${deviceTypes.mobile}'] & {
    flex-direction: column;
    align-items: start;
    gap: 6px;
  }
`;

export const ContentGroup = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  [data-device='${deviceTypes.mobile}'] & {
    row-gap: 8px;
  }
`;

export const DateContent = styled.div`
  font-size: 10px;
  font-weight: 500;
  color: #8f95b2;
`;

export const TriggeredByContent = styled.div`
  display: flex;
  border-radius: 4px;
  padding: 2px 4px;
  gap: 4px;
  background-color: #e6edff;
  max-width: fit-content;
  align-items: center;

  &.removed {
    background-color: #e6e8f0;
  }
`;

export const TriggeredByGroup = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;

  /* Todo: maybe Wrap event name */
  /* [data-device='${deviceTypes.mobile}'] & {
    row-gap: 6px;
    flex-wrap: wrap;
  } */
`;

export const TriggeredByText = styled.div`
  font-weight: 500;
  font-size: 12px;
  color: #1371fe;

  &.removed {
    color: #696f8c;
    text-decoration: line-through;
  }
`;

export const EventNameContent = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #696f8c;
  /* margin-left: 6px;
  margin-right: 12px; */
`;

export const NoHistoryText = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #474d66;
`;

export const NoHistoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: auto;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const TriggeredByPicture = styled.img`
  width: 12px;
  height: 12px;
  border-radius: 6px;

  &.removed {
    filter: grayscale(100%);
    -webkit-filter: grayscale(100%);
  }
`;

interface IStatusValue {
  value?: string;
}

export const StatusValue = styled.div<IStatusValue>`
  display: flex;
  flex-direction: row;
  max-height: 22px;
  padding: 2px 6px;
  gap: 4px;
  border-radius: 4px;
  align-items: center;
  justify-content: center;

  background-color: #e6edff;
  color: #1371fe;

  font-size: 12px;
  font-weight: 500;

  &.oldValue {
    text-decoration: line-through;
    background-color: #e6e8f0;
    color: #696f8c;
  }
`;

export const Circle = styled.div<IStatusValue>`
  width: 6.25px;
  height: 6.25px;
  border-radius: 3.125px;
  margin-top: -1px;

  // Temporary circle color until we get the right color values
  background-color: #1371fe;

  &.oldValue {
    background-color: #696f8c;
  }
`;

export const RowDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 6px;
  white-space: nowrap;
`;

export const ValueRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 6px;
  white-space: nowrap;

  column-gap: 12px;
  [data-device='${deviceTypes.mobile}'] & {
    flex-direction: column;
    align-items: flex-start;
  }
`;
export const IconWrapper = styled.div`
  margin-top: -3px;
`;

export const TextValues = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #1b203a;
  padding-top: 2px;

  &.removed {
    color: #8f95b2;
    text-decoration: line-through;
  }
`;

export const GenericTag = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #e6edff;
  color: #1371fe;
  height: 22px;
  border-radius: 15px;
  padding: 2px 8px;
  font-weight: 500;
  font-size: 12px;

  &.removed {
    text-decoration: line-through;
    background-color: #e6e8f0;
    color: #474d66;
  }
`;

export const EndOfHistory = styled.div`
  font-weight: 400;
  font-size: 12px;
  color: #8f95b2;
`;

export const ChatWrapper = styled.div`
  margin-top: 16px;
  width: 100%;
  position: -webkit-sticky;
  position: sticky;
  bottom: 0;
  background-color: #fff;
`;

export const Randomdiv = styled.div`
  flex: 1;
  overflow: auto;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

export const CommentDiv = styled.div`
  border: 1px solid #e6e8f0;
  border-radius: 4px;
  background-color: #f5f7fb;
  color: #696f8c;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 400;
  justify-content: center;
  margin-left: 20px;

  p,
  ul,
  ol {
    margin-bottom: 0;
  }

  em,
  u,
  strong,
  p,
  a {
    font-size: 12px;
  }
  ul,
  ol {
    margin-left: 20px;
  }
`;
